module.exports = __webpack_public_path__ + "static/media/footer_Logo.821e6933.png";